import React from "react";
import { Form } from "antd";
import APISelect from "../ApiSelect";

const { Item } = Form;

const InputAPISelect = (props) => {
  const { id, name, label, required, value, onChangeHandler } = props;
  return (
    <Item
      key={id}
      name={name}
      label={label}
      rules={[
        {
          required: required,
        },
      ]}
    >
      <APISelect
        {...props}
        value={value}
        label={label}
        onChange={(value) => onChangeHandler(value, id)}
      />
    </Item>
  );
};

export default InputAPISelect;
